

app.controller('OLDCIF2-CTRL', function ($scope, $rootScope, $routeParams, uibDateParser, $uibModal, $http, $window, $location, $timeout, Upload, $q, $filter) {
    $scope.form1 = false;
    $scope.form2 = false;
    $scope.form3 = false;
    $scope.form4 = false;
    $scope.listBankRDN = ['BCA (Online)', 'MANDIRI (Offline)', 'CIMB (Offline)', 'MAYAPADA (Offline)'];
    $scope.bankRDN = '';
    $scope.allowedExt = [
    '.jpg', '.jpeg', '.bmp', '.png', '.pdf'
    ];
    $scope.stepClass = ['', '', '', ''];
    $scope.stepActive = 'active current';
    $scope.current = 0;

    $scope.hideForm = function () {
        $scope.form1 = false;
        $scope.form2 = false;
        $scope.form3 = false;
        $scope.form4 = false;
        $scope.stepClass = ['', '', '', ''];
    }

    $scope.showForm = function (formIndex) {
        if (formIndex == 0)
            $window.location.href = "#/cif/start";
        else
            $window.location.href = "#/cif/" + (Number(formIndex));
    };

    if ($routeParams.stage == 'start' || !$routeParams.stage) {
        $scope.current = 0;
        $scope.form1 = true;
        $scope.stepClass[0] = $scope.stepActive;
    }
    else {
        try {
            $scope.current = Number($routeParams.stage);
            console.log('dsadsads');
            switch ($scope.current) {
                case 0: $scope.form1 = true; break;
                case 1: $scope.form2 = true; break;
                case 2: $scope.form3 = true; break;
                case 3: $scope.form4 = true; break;
            }
            $scope.stepClass[$scope.current] = $scope.stepActive;
        }
        catch (err) {
            $window.location.href = "#/";
            $window.location.reload();
        }
    }




    $scope.CIFInvestor = {
        FirstName: '',
        SpouseName: '',
        MotherMaidenName: '',
        Nationality: '',
        Country: '',
        Account: '1',
        IDCardNumber: '',
        IDExpiredDate: '',
        Sex: '',
        BirthPlace: '',
        BirthDate: '',
        Religion: '',
        MaritalStatus: '',
        Education: '',
        IDCardCity: '',
        IDCardKecamatan: '',
        IDCardKelurahan: '',
        IDCardRT: '',
        IDCardRW: '',
        IDCardPostalCode: '',
        IDCardAddress: '',
        IDCardCountry: '',
        DomicileCity: '',
        DomicileKecamatan: '',
        DomicileKelurahan: '',
        DomiciledRT: '',
        DomicileyRW: '',
        DomicilePostalCode: '',
        DomicileAddress: '',
        DomicileCountry: '',
        BankAccountName: '',
        BankCabang: '',
        BankOwner: '',
        BankAccountNumber: '',
        CompanyName: '',
        FundSourceText: '',
        NPWPNumber: '',
        NPWPReason: '',
        CompanyAddress: '',
        QuestionRDN: '1',
        Occupation: '',
        OccupationText: '',
        Occupation_BCA: '',
        OccupationText_BCA: '',
        SpouseOccupation: '',
        SpouseOccupationText: '',
        SpouseOccupationDescription: '',
        SpouseCompanyName: '',
        Position: '',
        Position_BCA: '',
        JabatanText_BCA: '',
        NatureOfBusiness: '',
        NatureOfBusinessText: '',
        NatureOfBusiness_BCA: '',
        NatureOfBusinessText_BCA: '',
        InvestmentObjective: '',
        InvestmentObjectiveText: '',
        FATCA1: '',
        FATCA2: '',
        FATCA3: '',
        Q1: '',
        Q2: '',
        Q3: '',
        Q4: '',
        Q5: '',
        Q6: '',
        Question1_Text: '',
        Question2_Text: '',
        Question3_Text: '',
        Question4_Text: '',
        Question5_Text: '',
        Question6_Text: '',
        filenameKTP: '',
        fileKTP: '',
        fileKTPext: '',
        tandaTangan: ''
    };

    //FORM 1 : IDENTITAS PRIBADI
    $scope.Kewarganegaraan = 'WNI / Indonesian';
    $scope.KewarganegaraanOption = ['WNI / Indonesian', 'Lainnya / Others'];
    $scope.IDLength = 16;
    $scope.chkSeumurHidup = true;
    $scope.DisabledSeumurHidup = true;
    $scope.disableBank = false;
    $scope.disablebankRDN = false;
    $scope.disableCIFInvestorQuestionRDN = false;
    $scope.CopyID = true;
    $scope.finishSignature = false;
    $scope.useCam = true;
    $scope.camLoading = true;

    $scope.ListNationality = [];
    $scope.ListLookup = [];

    $scope.updatebankaccountname = function () {
        $scope.CIFInvestor.FirstName = $scope.CIFInvestor.name;
    }
    $scope.KewarganegaraanChange = function () {
        if ($scope.Kewarganegaraan == 'WNI / Indonesian') {
            $scope.IDLength = 16;
            $scope.chkSeumurHidup = true;
            $scope.DisabledSeumurHidup = true;
        }
        else if ($scope.Kewarganegaraan == 'Lainnya / Others') {
            $scope.IDLength = 8;
            $scope.chkSeumurHidup = false;
            $scope.DisabledSeumurHidup = true;
        }
    }

    $scope.selectNationality = function (item, model, label, event) {
        $scope.CIFInvestor.Nationality = item;
        $scope.CIFInvestor.Country = item;
    };

    $scope.selectIDCardCountry = function (item, model, label, event) {
        $scope.CIFInvestorID.CardCountry = item;
    };

    $scope.selectIDCardCity = function (item, model, label, event) {
        $scope.CIFInvestor.IDCardCity = item;

        if ($scope.CIFInvestor.IDCardCity.CIFProvinceCityNID) {
            var tmpidcardCountry = $filter('filter')($scope.ListCountry, { key: 102 }, true)[0];
            var idcardcountry = tmpidcardCountry;

            $scope.CIFInvestor.IDCardCountry = idcardcountry;
            $scope.disablecountry = true;
        }
        else {
            $scope.CIFInvestor.IDCardCountry = "";
            $scope.disablecountry = false;
        }
    };

    $scope.idcardcityChange = function () {
        var idcardCountry = $filter('filter')($scope.ListCountry, { key: 102 }, true)[0];

        if ($scope.CIFInvestor.IDCardCity == null) {
            $scope.disablecountry = false;
            $scope.CIFInvestor.IDCardCountry = '';
        }
        else {
            $scope.CIFInvestor.IDCardCountry = idcardCountry;
            $scope.disablecountry = true;
        }
    };

    $scope.selectBankPribadi = function (item, model, label, event) {
        $scope.CIFInvestor.BankAccountName = item;
    };

    $scope.questionRDNchange = function () {
        if ($scope.CIFInvestor.QuestionRDN == 1 || $scope.CIFInvestor.QuestionRDN == 2 || $scope.CIFInvestor.QuestionRDN == 3 || $scope.CIFInvestor.QuestionRDN == 4) {
            $scope.CIFJabatanText_BCA = '';
            $scope.CIFNatureOfBusinessText_BCA = '';
            $scope.CIFInvestorOccupationText_BCA = '';
            $scope.CIFInvestorOccupation = {};

            //$scope.disableCIFInvestor.QuestionRDN = false;
            if ($scope.CIFInvestorQuestionRDN == '1')
                $scope.bankRDN = $scope.listBankRDN[0];


            if ($scope.CIFInvestor.QuestionRDN == '2')
                $scope.bankRDN = $scope.listBankRDN[1];

            if ($scope.CIFInvestor.QuestionRDN == '3')
                $scope.bankRDN = $scope.listBankRDN[2];

            if ($scope.CIFInvestor.QuestionRDN == '4')
                $scope.bankRDN = $scope.listBankRDN[3];
        }
        else {

        }

        if ($scope.CIFInvestor.QuestionRDN == 1) {
            $scope.CIFInvestor.BankAccountName = "PT. BANK CENTRAL ASIA, Tbk.";

        }
        else {
            $scope.CIFInvestor.BankAccountName = " ";

        }
        //$scope.disableCIFInvestor.QuestionRDN = true;

        if ($scope.CIFInvestor.BankOwner) {
            $scope.CIFInvestor.FirstName = $scope.CIFInvestor.BankOwner;
        }

    };

    $scope.CopyFromID = function () {
        if ($scope.CopyID) {
            $scope.CIFInvestor.DomicilePostalCode = $scope.CIFInvestor.IDCardPostalCode;
            $scope.CIFInvestor.DomicileAddress = $scope.CIFInvestor.IDCardAddress;
            $scope.CIFInvestor.DomiciledRT = $scope.CIFInvestor.IDCardRT;
            $scope.CIFInvestor.DomiciledRW = $scope.CIFInvestor.IDCardRW;
            $scope.CIFInvestor.DomicileKelurahan = $scope.CIFInvestor.IDCardKelurahan;
            $scope.CIFInvestor.DomicileKecamatan = $scope.CIFInvestor.IDCardKecamatan;
            $scope.CIFInvestor.DomicileCity = $scope.CIFInvestor.IDCardCity;
            $scope.CIFInvestor.DomicileCountry = $scope.CIFInvestor.IDCardCountry;
        }
        else {
            $scope.CIFInvestor.IDCardPostalCode = '';
            $scope.CIFInvestor.IDCardAddress = '';
            $scope.CIFInvestor.IDCardRT = '';
            $scope.CIFInvestor.IDCardRW = '';
            $scope.CIFInvestor.IDCardKelurahan = '';
            $scope.CIFInvestor.IDCardKecamatan = '';
            $scope.CIFInvestor.IDCardCity = '';
            $scope.CIFInvestor.IDCardCountry = '';
        }
    };

    $scope.printXyz = function () {
        console.log($scope.CIFInvestor);
    }

    //FROM 2 : DATA PEKERJAAN
    $scope.updateNPWP = function () {
        if ($scope.CIFInvestor.NPWPNumber) {
            if (+$scope.QuestionNPWP == 1) {
                $scope.CIFInvestor.NPWPNumber;
            }
            else {
                $scope.CIFInvestor.NPWPReason;
                $scope.CIFInvestor.NPWPNumber = '';
            }
        }
    };

    $scope.selectedFundSource = [];
    $scope.selectedFundSourceText = [];
    $scope.selectedInvestmentObjective = [];
    $scope.selectedInvestmentObjectiveText = [];

    $scope.CIFInvestorOccupation_BCA = '';
    $scope.CIFInvestorPosition_BCA = {};
    $scope.CIFInvestorNatureOfBusiness_BCA = {};
    $scope.CIFInvestorOccupationText_BCA = '';
    $scope.CIFJabatanText_BCA = '';
    $scope.CIFNatureOfBusinessText_BCA = '';

    $scope.listpekerjaan_BCA = {};
    $scope.listjabatan_BCA = {};
    $scope.listusaha_BCA = {};

    $scope.profesiChange_BCA = function () {
        if ($scope.CIFInvestor.Occupation_BCA) {
            $scope.CIFInvestor.OccupationText_BCA = '';
            $scope.profesi = $scope.CIFInvestor.Occupation_BCA.value;

            if ($scope.CIFInvestor.Occupation_BCA.key == 18)
                $scope.profesi += ' : ' + $scope.CIFInvestor.OccupationText_BCA;


            if ($scope.CIFInvestor.Occupation_BCA.key == 1)
                $scope.spouseMandatory = true;


            $http({
                method: 'GET',
                url: '/service/client.svc/GetJabatan?Pekerjaan=' + $scope.CIFInvestor.Occupation_BCA.key,
            }).then(function (data) {
                $scope.listjabatan_BCA = data.data.d;

                if ($scope.listjabatan_BCA.length) {
                    $scope.CIFInvestor.JabatanText_BCA = '';
                    $scope.CIFInvestor.Position_BCA = $scope.listjabatan_BCA[0];
                    $scope.CIFInvestor.Position = $scope.CIFInvestor.Position_BCA.value;
                    if ($scope.CIFInvestor.Position_BCA.key == 0)
                        $scope.CIFInvestor.Position = $scope.CIFInvestor.JabatanText_BCA;
                    $scope.jabatanChange_BCA();
                }
            }, function (error) { });
        }
    };

    $scope.profesiChange = function () {
        console.log($scope.CIFInvestor.Occupation);
        if ($scope.CIFInvestor.Occupation) {
            $scope.RequiredForInvestorOccupation = true;

            if ($scope.CIFInvestor.Occupation.CIFLookupNID == 64)
                $scope.spouseMandatory = true;

            if ($scope.CIFInvestor.Occupation.CIFLookupNID == 59)
                $scope.profesi = $scope.CIFInvestor.OccupationText;
            else {
                $scope.profesi = $scope.CIFInvestor.Occupation.Description;
                $scope.CIFInvestor.OccupationText = "";
            }

            if ($scope.CIFInvestor.Occupation.CIFLookupNID == 63) {
                $scope.disableBidangUsaha = false;
                $scope.requiredBidangUsaha = true;
            }
            else {
                $scope.disableBidangUsaha = true;
                $scope.requiredBidangUsaha = false;
                $scope.CIFInvestor.NatureOfBusiness = '';
            }
        }
        else
            $scope.RequiredForInvestorOccupation = false;
    };

    $scope.bidangusahaChange = function () {
        if ($scope.CIFInvestorNatureOfBusiness) {
            if ($scope.CIFInvestorNatureOfBusiness.CIFLookupNID == 271)
                $scope.bidangUsaha = $scope.CIFInvestorNatureOfBusinessText
            else {
                $scope.bidangUsaha = $scope.CIFInvestorNatureOfBusiness.Description;
                $scope.CIFInvestorNatureOfBusinessText = "";
            }
        }
    };

    $scope.jabatanChange_BCA = function () {
        $scope.CIFInvestor.Position = $scope.CIFInvestor.Position_BCA.value;
        if ($scope.CIFInvestor.Position_BCA.key == 0)
            $scope.CIFInvestor.Position = $scope.CIFJabatanText_BCA;

        $http({
            method: 'GET',
            url: '/service/client.svc/GetBidangUsaha?Jabatan=' + $scope.CIFInvestor.Position_BCA.key + '&Pekerjaan=' + $scope.CIFInvestor.Occupation_BCA.key,
        }).then(function (data) {
            $scope.listusaha_BCA = data.data.d;

            if ($scope.listusaha_BCA.length) {
                $scope.CIFInvestor.NatureOfBusinessText_BCA = '';
                $scope.CIFInvestor.NatureOfBusiness_BCA = $scope.listusaha_BCA[0];
                $scope.bidangUsaha = $scope.CIFInvestor.NatureOfBusiness_BCA.value;

                if ($scope.CIFInvestor.NatureOfBusiness_BCA.key == 0)
                    $scope.bidangUsaha = $scope.CIFInvestor.NatureOfBusinessText_BCA;
            }
            console.log("asdasd", $scope.listusaha_BCA);
        }, function (error) { });
    };

    $scope.bindJabatan = function (jabatan, usaha) {

        if ($scope.CIFInvestorOccupation_BCA) {
            $http({
                method: 'GET',
                url: '/service/client.svc/GetJabatan?Pekerjaan=' + $scope.CIFInvestorOccupation_BCA.key,
            }).then(function (data) {
                $scope.listjabatan_BCA = data.data.d;
                if ($scope.listjabatan_BCA.length) {
                    $scope.CIFInvestorPosition_BCA = $filter('filter')($scope.listjabatan_BCA, { key: Number(jabatan) }, true)[0];

                    $scope.CIFInvestorPosition = $scope.CIFInvestorPosition_BCA.value;
                    if ($scope.CIFInvestorPosition_BCA.key == 0)
                        $scope.CIFInvestorPosition = $scope.CIFJabatanText_BCA;
                    $scope.bindUsaha(usaha);

                }
            }, function (error) { });
        }
    }

    $scope.bindUsaha = function (usaha) {
        if ($scope.CIFInvestorOccupation_BCA) {
            $http({
                method: 'GET',
                url: '/service/client.svc/GetBidangUsaha?Jabatan=' + $scope.CIFInvestorPosition_BCA.key + '&Pekerjaan=' + $scope.CIFInvestorOccupation_BCA.key,
            }).then(function (data) {
                $scope.listusaha_BCA = data.data.d;

                if ($scope.listusaha_BCA.length) {
                    $scope.CIFInvestorNatureOfBusiness_BCA = $filter('filter')($scope.listusaha_BCA, { key: Number(usaha) }, true)[0];
                    $scope.bidangUsaha = $scope.CIFInvestorNatureOfBusiness_BCA.value;

                    if ($scope.CIFInvestorNatureOfBusiness_BCA.key == 0)
                        $scope.bidangUsaha = $scope.CIFNatureOfBusinessText_BCA;

                }
            }, function (error) { });
        }
    }

    $scope.selectPosition = function (item, index) {
        if (index == 1)
            $scope.CIFInvestor.Position = item.CIFLookupDescription;
    };

    $scope.toggleFundSourceItem = function (fundsource) {
        var indexCIFLookupInteger = $scope.selectedFundSource.indexOf(fundsource.CIFLookupInteger);
        var indexCIFLookupDescription = $scope.selectedFundSourceText.indexOf(fundsource.CIFLookupDescription);

        if (indexCIFLookupInteger > -1) {
            $scope.selectedFundSource.splice(indexCIFLookupInteger, 1);
            $scope.selectedFundSourceText.splice(indexCIFLookupDescription, 1);
        }
        else {
            $scope.selectedFundSource.push(fundsource.CIFLookupInteger);
            $scope.selectedFundSourceText.push(fundsource.CIFLookupDescription);
        }

        if ($scope.selectedFundSource.indexOf(1) < 0)
            $scope.CIFInvestor.FundSourceText = '';


    }

    $scope.toggleInvestmentObjectiveItem = function (InvestmentObjectives) {
        var indexCIFLookupInteger = $scope.selectedInvestmentObjective.indexOf(InvestmentObjectives.CIFLookupInteger);
        var indexCIFLookupDescription = $scope.selectedInvestmentObjectiveText.indexOf(InvestmentObjectives.CIFLookupDescription);

        if (indexCIFLookupInteger > -1) {
            $scope.selectedInvestmentObjective.splice(indexCIFLookupInteger, 1);
            $scope.selectedInvestmentObjectiveText.splice(indexCIFLookupDescription, 1);
        }
        else {
            $scope.selectedInvestmentObjective.push(InvestmentObjectives.CIFLookupInteger);
            $scope.selectedInvestmentObjectiveText.push(InvestmentObjectives.CIFLookupDescription);
        }

        if ($scope.selectedInvestmentObjective.indexOf(1) < 0)
            $scope.CIFInvestorInvestmentObjectiveText = '';
    }

    $scope.spouseprofesiChange = function () {

        if ($scope.CIFInvestor.SpouseOccupation) {
            $scope.RequiredFor.SpouseOccupation = true;

            if ($scope.CIFInvestor.SpouseOccupation.CIFLookupNID == 59)
                $scope.spouseProfesi = $scope.CIFInvestor.SpouseOccupationText;
            else {
                $scope.spouseProfesi = $scope.CIFInvestor.SpouseOccupationDescription;
                $scope.CIFInvestor.SpouseOccupationText = "";
            }


            if ($scope.CIFInvestor.SpouseOccupation.CIFLookupNID == 62) {
                $scope.RequiredForSpouseOccupation = true;
                $scope.disableSpousePosition = true;
                $scope.changeSpouseMandatory(false);
            }
            else
                $scope.disableSpousePosition = false;
            $scope.RequiredForSpouseOccupation = false;

            if ($scope.CIFInvestor.SpouseOccupation.CIFLookupNID == 63) {
                $scope.disableSpouseBidangUsaha = false;
                $scope.requiredSpouseBidangUsaha = true;
            }
            else {

                $scope.disableSpouseBidangUsaha = true;
                $scope.requiredSpouseBidangUsaha = false;
                $scope.CIFInvestor.SpouseNatureOfBusiness = '';
            }


        }
        else
            $scope.RequiredForSpouseOccupation = false;
        //console.log($scope.CIFInvestorSpouseOccupation);
    };

    //FROM 3 : DATA PENDUKUNG
    $scope.updateQ1 = function () {
        if ($scope.Q1) {
            if (+$scope.Q1 == 1) {
                $scope.CIFInvestorQuestion1 = "Ya";
            }
            else {
                $scope.CIFInvestorQuestion1 = "Tidak";
                $scope.CIFInvestorQuestion1_Text = '';
            }
        }
    };

    $scope.updateQ2 = function () {
        if ($scope.Q2) {
            if (+$scope.Q2 == 1) {
                $scope.CIFInvestorQuestion2 = "Ya";
            }
            else {
                $scope.CIFInvestorQuestion2 = "Tidak";
                $scope.CIFInvestorQuestion2_Text = '';
            }
        }
    };

    $scope.updateQ3 = function () {
        if ($scope.Q3) {
            if (+$scope.Q3 == 1) {
                $scope.CIFInvestorQuestion3 = "Ya";
            }
            else {
                $scope.CIFInvestorQuestion3 = "Tidak";
                $scope.CIFInvestorQuestion3_Text = '';
            }
        }
    };

    $scope.updateQ4 = function () {
        if ($scope.Q4) {
            if (+$scope.Q4 == 1) {
                $scope.CIFInvestorQuestion4 = "Ya";
            }
            else {
                $scope.CIFInvestorQuestion4 = "Tidak";
                $scope.CIFInvestorQuestion4_Text = '';
            }
        }
    };

    $scope.updateQ5 = function () {
        if ($scope.Q5) {
            if (+$scope.Q5 == 1) {
                $scope.CIFInvestorQuestion5 = "Ya";
            }
            else {
                $scope.CIFInvestorQuestion5 = "Tidak";
                $scope.CIFInvestorQuestion5_Text = '';
            }
        }
    };

    $scope.updateQ6 = function () {
        if ($scope.Q6) {
            if (+$scope.Q6 == 1) {
                $scope.CIFInvestorQuestion6 = "Ya";
            }
            else {
                $scope.CIFInvestorQuestion6 = "Tidak";
                $scope.CIFInvestorQuestion6_Text = '';
            }
        }
    };

    // FROM 4 : DATA LAINNYA
    $scope.KTPFile = [];
    $scope.disclaimerBank = false;

    $scope.filenameFotoDiri = "";
    $scope.fileFotoDiri = "";
    $scope.fileFotoDiriext = "";
    $scope.fotodiriFile = [];

    $scope.filenameTandaTangan = "";
    $scope.fileTandaTangan = "";
    $scope.fileTandaTanganext = "";
    $scope.tandatanganFile = [];

    $scope.selectKTP = function (files) {
        $scope.KTPFile = files;
        let allowed = true;
        var reader = new FileReader();

        reader.onload = function (e) {
            if (allowed) {
                $scope.CIFInvestor.fileKTP = btoa(e.target.result.toString());
            }
        };

        reader.readAsBinaryString(files[0]);
        $scope.CIFInvestor.fileKTPext = files[0].name.substr(files[0].name.lastIndexOf('.'));

        if ($scope.allowedExt.indexOf($scope.CIFInvestor.fileKTPext.toLowerCase()) < 0) {
            allowed = false;
            $scope.CIFInvestor.fileKTPext = '';
            $scope.KTPFile = '';
            alert("Extensi yang dibolehkan : " + $scope.allowedExt);
        }
        else
            $scope.CIFInvestor.filenameKTP = files[0].name;
    };

    $scope.selectFotoDiri = function (files) {
        $scope.fotodiriFile = files;
        let allowed = true;
        var reader = new FileReader();

        reader.onload = function (e) {
            if (allowed) {
                $scope.fileFotoDiri = btoa(e.target.result.toString());
            }
        };

        reader.readAsBinaryString(files[0]);
        $scope.fileFotoDiriext = files[0].name.substr(files[0].name.lastIndexOf('.'));
        if ($scope.allowedExt.indexOf($scope.fileFotoDiriext.toLowerCase()) < 0) {
            allowed = false;
            $scope.fileFotoDiriext = '';
            $scope.fotodiriFile = '';
            alert("Extensi yang dibolehkan : " + $scope.allowedExt);
        }
        else
            $scope.filenameFotoDiri = files[0].name;
    };

    $scope.selectTandaTangan = function (files) {
        $scope.tandatanganFile = files;
        let allowed = true;
        var reader = new FileReader();

        reader.onload = function (e) {
            if (allowed) {
                $scope.fileTandaTangan = btoa(e.target.result.toString());
            }
        };

        reader.readAsBinaryString(files[0]);
        $scope.fileTandaTanganext = files[0].name.substr(files[0].name.lastIndexOf('.'));
        if ($scope.allowedExt.indexOf($scope.fileTandaTanganext.toLowerCase()) < 0) {
            allowed = false;
            $scope.fileTandaTanganext = '';
            $scope.tandatanganFile = '';
            alert("Extensi yang dibolehkan : " + $scope.allowedExt);
        }
        else
            $scope.filenameTandaTangan = files[0].name;
    };

    $scope.clickRemoveKTP = function (file, event, key) {
        event.preventDefault();
        $scope.CIFInvestor.fileKTP = "";
        $scope.CIFInvestor.filenameKTP = "";
        $scope.CIFInvestor.fileKTPext = "x";
        $scope.KTPFile.splice(key, 1);
        $scope.KTPFile = [];
        return null;
    };

    $scope.clickRemoveFotoDiri = function (file, event, key) {
        event.preventDefault();
        $scope.fileFotoDiri = "";
        $scope.filenameFotoDiri = "";
        $scope.fileFotoDiriext = "x";
        $scope.fotodiriFile.splice(key, 1);
        $scope.fotodiriFile = [];

        return null;
    };

    $scope.clickRemoveTandaTangan = function (file, event, key) {
        event.preventDefault();
        $scope.fileTandaTangan = "";
        $scope.filenameTandaTangan = "";
        $scope.fileTandaTanganext = "x";
        $scope.tandatanganFile.splice(key, 1);
        $scope.tandatanganFile = [];
        return null;
    };

    $scope.agree1 = false;
    $scope.agree2 = false;

    $scope.validateAgreement = function () {
        if (!$scope.agree1 || !$scope.agree2) {
            $scope.disclaimerBank = false;
            swal('Error', 'Mohon klik PERNYATAAN NASABAH RDN BCA dan KETENTUAN-KETENTUAN TAPRES PT BANK CENTRAL ASIA Tbk.', 'error');
        }
    }

    $scope.modalMessage = {
        message: '',
        param: {}
    };
    $scope.openModal = function () {
        var tempUrl = 'myModalContent.html';
        if ($scope.buttonText == "Save")
            tempUrl = 'myModalContentSementara.html';
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: tempUrl,
            controller: 'ModalInstanceCIFCtrl',
            size: 'md',
            resolve: {
                items: function () {
                    return $scope.modalMessage;
                }
            }
        });
    };

    $scope.showAgreement = function (number) {
        let htmlName = 'agreement' + number + '.html';
        var modalInstance = $uibModal
        .open({
            animation: true,
            templateUrl: htmlName,
            controller: 'BCAAgreementCtrl',
            size: 'lg',
            backdrop: 'static',
            resolve: {
                agreementNumber: function () {
                    return number;
                }
            }
        });
        modalInstance.result.then(function (response, agree) {
            if (response == 'accept') {
                if (number == 1)
                    $scope.agree1 = true;
                if (number == 2)
                    $scope.agree2 = true;
            }
        }, function () { });
    };



    var allPromise = $q.all([
        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFCountry',
            cache: true,
        }).then(function (data) {
            $scope.ListNationality = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFCountryAll',
            cache: true,
        }).then(function (data) {
            $scope.ListCountry = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFProvinceCity',
            cache: true,
        }).then(function (data) {
            $scope.ListProvinceCity = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFLookup',
            cache: true,
        }).then(function (data) {
            $scope.ListLookup = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFBank',
            cache: true,
        }).then(function (data) {
            $scope.ListBank = data.data.d;
        }, function (error) { }),

        $http({
            method: 'GET',
            url: '/service/client.svc/GetCIFPekerjaan',
            cache: true,
        }).then(function (data) {
            $scope.listpekerjaan_BCA = data.data.d;
        }, function (error) { }),
    ]);



    allPromise.then(function () {

    });

    $scope.take_snapshot = function () {
        Webcam.snap(function (data_uri) {
            $scope.KTP.file = data_uri;
            $scope.KTP.filename = "camera_" + $scope.firstname;
            Webcam.reset();
        });

    }


    $scope.resetSign = function () {
        $scope.finishSignature = false;
        $scope.clear();
    };

    $scope.completeSign = function () {

        $scope.signature = $scope.accept();
        if ($scope.signature.dataUrl && !$scope.signature.isEmpty) {
            $scope.finishSignature = true;
            $scope.CIFInvestor.tandaTangan = $scope.signature.dataUrl.substr($scope.signature.dataUrl.lastIndexOf(',') + 1);
        }
        else
            $scope.finishSignature = false;
    };


});





app.controller('OLDBCAAgreementCtrl', function ($scope, $uibModalInstance, agreementNumber, $window) {

    $scope.agreementNumber = agreementNumber;
    console.log('open', $scope.agreementNumber);
    $scope.accept = function () {
        $uibModalInstance.close('accept', $scope.agreementNumber);
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel', $scope.agreementNumber);
    };
});